import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState, useRef } from 'react';
import Box from "../Box";
import Typography from "../Typography";
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@pixel/assets/icons/Close";
import Paper from '../Paper';
import StandardTooltip from '../StandardTooltip';
import InfoIcon from '@mui/icons-material/Info';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import ErrorIcon from '@mui/icons-material/Error';
import Link from '../Link';
import { styled, useTheme } from "../styles";
import ErrorBoundary from "../ErrorBoundary";
import CircularProgress from "../CircularProgress";
export const ImageBorder = styled("div")(_ref => {
  let {
    theme
  } = _ref;
  return {
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    border: "1px solid ".concat(theme.palette.success.softBackground),
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    "& > button": {
      float: 'right',
      zIndex: '1',
      top: theme.spacing(.25),
      right: theme.spacing(.25),
      position: 'absolute'
    }
  };
});
export const ImageLoadingBorder = styled("div")(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    border: "1px solid ".concat(theme.palette.success.softBackground),
    position: 'relative',
    borderRadius: Number(theme.shape.borderRadius) * .25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };
});
export const ImageErrorBorder = styled("div")(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    background: theme.palette.common.white,
    overflow: 'hidden',
    border: "1px solid ".concat(theme.palette.error.main),
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    "& > button": {
      float: 'right',
      zIndex: '1',
      top: theme.spacing(.25),
      right: theme.spacing(.25),
      position: 'absolute'
    }
  };
});
const DragLabelStyle = {
  cursor: 'pointer',
  display: 'block',
  height: '100%',
  paddingTop: '14%'
};
export const ImageUploadContainer = styled("div")(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    border: "1px solid ".concat(theme.palette.success.softBackground),
    position: 'relative',
    borderRadius: Number(theme.shape.borderRadius) * .25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };
});
export const DragDropContainer = styled("div")(_ref5 => {
  let {
    theme
  } = _ref5;
  return {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: theme.shape.borderRadius,
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px'
  };
});
const ImageUpload = _ref6 => {
  let {
    id = 'select-image',
    crossIconButtonText = 'Remove Image',
    imageUploadCaption = 'Image Uploader',
    width = '240px',
    height = '240px',
    error = false,
    errorText = 'Error text',
    errorConfirmationText = 'Okay',
    imageUploaderHelperText,
    uploadButtonCaption = 'Drag & Drop Image (JPG, PNG, GIF)',
    imageUploadtitle = 'Upload Image',
    acceptedImageFormats = 'image/png, image/gif, image/jpeg',
    showCloseIcon = true,
    isImageUploading = false,
    uploadProgressPercentage = 0,
    imageUrl,
    alternateText,
    handleFileChange,
    onToggleErrorState,
    onCloseIcon
  } = _ref6;
  const theme = useTheme();
  const ImageUploadwrapper = styled("div")({
    height: Number(height.slice(0, -2)) + 62 + 'px',
    width: Number(width.slice(0, -2)) + 32 + 'px',
    ".MuiSvgIcon-root": {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5)
    }
  });
  const [dragActive, setDragActive] = useState(false);
  const [dragError, setDragError] = useState(false);
  const [errorDescription, setErrorDescription] = useState(null);
  const inputRef = useRef(null);
  const handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  const onToggleDragErrorState = () => {
    setDragError(false);
    setErrorDescription(null);
  };
  const ValidateFileType = file => {
    let fileType = acceptedImageFormats.replaceAll(' ', '').toLowerCase().split(',');
    return fileType.includes(file.type.toLowerCase());
  };
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      if (ValidateFileType(e.dataTransfer.files[0])) {
        if (e.dataTransfer.files.length > 1) {
          setDragError(true);
          setErrorDescription('Only one file is permitted');
        } else {
          handleFileChange(e.dataTransfer.files[0]);
        }
      } else {
        setDragError(true);
        setErrorDescription('This file type is not permitted');
      }
    }
  };
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    square: true,
    style: {
      padding: 8
    }
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ImageUploadwrapper, null, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      float: 'left',
      width: '88%'
    },
    variant: "body2"
  }, imageUploadCaption), imageUploaderHelperText && /*#__PURE__*/React.createElement(StandardTooltip, {
    title: imageUploaderHelperText
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    sx: {
      float: 'right',
      pt: theme.spacing(.375)
    }
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      background: theme.palette.background.secondary,
      p: 2,
      borderRadius: Number(theme.shape.borderRadius) * .25,
      clear: 'both'
    }
  }, isImageUploading && /*#__PURE__*/React.createElement(ImageLoadingBorder, {
    sx: {
      width,
      height
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    size: 50,
    variant: "determinate",
    value: uploadProgressPercentage
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      ...theme.typography.caption
    },
    color: theme.palette.text.secondary
  }, "".concat(Math.round(uploadProgressPercentage), "%")))), !isImageUploading && !error && !dragError && /*#__PURE__*/React.createElement(ImageBorder, {
    sx: {
      width,
      height
    }
  }, imageUrl && showCloseIcon && /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: onCloseIcon,
    "aria-label": crossIconButtonText
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), !imageUrl && /*#__PURE__*/React.createElement(Box, {
    onDragEnter: handleDrag,
    sx: {
      cursor: 'pointer',
      textAlign: 'center',
      display: 'table-cell',
      verticalAlign: 'middle',
      width,
      height
    }
  }, /*#__PURE__*/React.createElement("input", {
    accept: acceptedImageFormats,
    type: "file",
    ref: inputRef,
    id: id,
    style: {
      display: 'none'
    },
    onChange: e => handleFileChange(e.target.files[0]),
    onClick: e => {
      e.currentTarget.value = null;
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    style: dragActive ? {
      ...DragLabelStyle,
      backgroundColor: theme.palette.grey[300]
    } : DragLabelStyle
  }, /*#__PURE__*/React.createElement(FileUploadIcon, {
    color: "action"
  }), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      m: 1
    }
  }, uploadButtonCaption), /*#__PURE__*/React.createElement(Link, {
    color: "primary",
    underline: "none",
    variant: "body2"
  }, imageUploadtitle)), dragActive && /*#__PURE__*/React.createElement(DragDropContainer, {
    onDragEnter: handleDrag,
    onDragLeave: handleDrag,
    onDragOver: handleDrag,
    onDrop: handleDrop
  })), imageUrl && /*#__PURE__*/React.createElement(Box, {
    sx: {
      textAlign: "center",
      width,
      height,
      display: 'table-cell',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    alt: alternateText,
    style: {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  }))), !isImageUploading && (error || dragError) && /*#__PURE__*/React.createElement(ImageErrorBorder, {
    sx: {
      width,
      height
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      textAlign: "center",
      width,
      height,
      display: 'table-cell',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React.createElement(ErrorIcon, {
    color: "error"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    sx: {
      m: 1
    }
  }, errorDescription ? errorDescription : errorText), !dragError && /*#__PURE__*/React.createElement(Link, {
    color: "primary",
    onClick: onToggleErrorState,
    underline: "none",
    variant: "body2"
  }, errorConfirmationText), dragError && /*#__PURE__*/React.createElement(Link, {
    color: "primary",
    onClick: onToggleDragErrorState,
    underline: "none",
    variant: "body2"
  }, errorConfirmationText)))))))));
};
export default ImageUpload;